const WIFI = "Wi-Fi";
const WIFI_CELLULAR = "Wi-Fi + Cellular";

export const APPLE_DEVICE_MODELS = {
	"iPhone10,1": "iPhone 8",
	"iPhone10,2": "iPhone 8 Plus",
	"iPhone10,3": "iPhone X",
	"iPhone10,4": "iPhone 8",
	"iPhone10,5": "iPhone 8 Plus",
	"iPhone10,6": "iPhone X",
	"iPhone11,2": "iPhone XS",
	"iPhone11,4": "iPhone XS Max",
	"iPhone11,6": "iPhone XS Max",
	"iPhone11,8": "iPhone XR",
	"iPhone12,1": "iPhone 11",
	"iPhone12,3": "iPhone 11 Pro",
	"iPhone12,5": "iPhone 11 Pro Max",
	"iPhone12,8": "iPhone SE (2nd generation)",
	"iPhone13,1": "iPhone 12 mini",
	"iPhone13,2": "iPhone 12",
	"iPhone13,3": "iPhone 12 Pro",
	"iPhone13,4": "iPhone 12 Pro Max",
	"iPhone14,2": "iPhone 13 Pro",
	"iPhone14,3": "iPhone 13 Pro Max",
	"iPhone14,4": "iPhone 13 mini",
	"iPhone14,5": "iPhone 13",
	"iPhone14,6": "iPhone SE (3rd generation)",
	"iPhone14,7": "iPhone 14",
	"iPhone14,8": "iPhone 14 Plus",
	"iPhone15,2": "iPhone 14 Pro",
	"iPhone15,3": "iPhone 14 Pro Max",
	"iPhone15,4": "iPhone 15",
	"iPhone15,5": "iPhone 15 Plus",
	"iPhone16,1": "iPhone 15 Pro",
	"iPhone16,2": "iPhone 15 Pro Max",
	"iPhone17,1": "iPhone 16 Pro",
	"iPhone17,2": "iPhone 16 Pro Max",
	"iPhone17,3": "iPhone 16",
	"iPhone17,4": "iPhone 16 Plus",
	"iPhone17,5": "iPhone 16e",
	"iPhone18,1": "iPhone 17 Pro",
	"iPhone18,2": "iPhone 17 Pro Max",
	"iPhone18,3": "iPhone 17",
	"iPhone18,4": "iPhone Air",
	"iPhone18,5": "iPhone 17e",

	"iPad6,11": `iPad (5th generation) ${WIFI}`,
	"iPad6,12": `iPad (5th generation) ${WIFI_CELLULAR}`,
	"iPad7,5": `iPad (6th generation) ${WIFI}`,
	"iPad7,6": `iPad (6th generation) ${WIFI_CELLULAR}`,
	"iPad7,11": `iPad (7th generation) ${WIFI}`,
	"iPad7,12": `iPad (7th generation) ${WIFI_CELLULAR}`,
	"iPad11,6": `iPad (8th generation) ${WIFI}`,
	"iPad11,7": `iPad (8th generation) ${WIFI_CELLULAR}`,
	"iPad12,1": `iPad (9th generation) ${WIFI}`,
	"iPad12,2": `iPad (9th generation) ${WIFI_CELLULAR}`,
	"iPad13,18": `iPad (10th generation) ${WIFI}`,
	"iPad13,19": `iPad (10th generation) ${WIFI_CELLULAR}`,
	"iPad15,7": `iPad (A16) ${WIFI}`,
	"iPad15,8": `iPad (A16) ${WIFI_CELLULAR}`,

	"iPad11,1": `iPad mini (5th generation) ${WIFI}`,
	"iPad11,2": `iPad mini (5th generation) ${WIFI_CELLULAR}`,
	"iPad14,1": `iPad mini (6th generation) ${WIFI}`,
	"iPad14,2": `iPad mini (6th generation) ${WIFI_CELLULAR}`,
	"iPad16,1": `iPad mini (A17 Pro) ${WIFI}`,
	"iPad16,2": `iPad mini (A17 Pro) ${WIFI_CELLULAR}`,

	"iPad11,3": `iPad Air (3rd generation) ${WIFI}`,
	"iPad11,4": `iPad Air (3rd generation) ${WIFI_CELLULAR}`,
	"iPad13,1": `iPad Air (4th generation) ${WIFI}`,
	"iPad13,2": `iPad Air (4th generation) ${WIFI_CELLULAR}`,
	"iPad13,16": `iPad Air (5th generation) ${WIFI}`,
	"iPad13,17": `iPad Air (5th generation) ${WIFI_CELLULAR}`,
	"iPad14,8": `iPad Air 11-inch (M2) ${WIFI}`,
	"iPad14,9": `iPad Air 11-inch (M2) ${WIFI_CELLULAR}`,
	"iPad14,10": `iPad Air 13-inch (M2) ${WIFI}`,
	"iPad14,11": `iPad Air 13-inch (M2) ${WIFI_CELLULAR}`,
	"iPad15,3": `iPad Air 11-inch (M3) ${WIFI}`,
	"iPad15,4": `iPad Air 11-inch (M3) ${WIFI_CELLULAR}`,
	"iPad15,5": `iPad Air 13-inch (M3) ${WIFI}`,
	"iPad15,6": `iPad Air 13-inch (M3) ${WIFI_CELLULAR}`,
	"iPad16,8": `iPad Air 11-inch (M4) ${WIFI}`,
	"iPad16,9": `iPad Air 11-inch (M4) ${WIFI_CELLULAR}`,
	"iPad16,10": `iPad Air 13-inch (M4) ${WIFI}`,
	"iPad16,11": `iPad Air 13-inch (M4) ${WIFI_CELLULAR}`,

	"iPad7,1": `iPad Pro (12.9-inch) (2nd generation) ${WIFI}`,
	"iPad7,2": `iPad Pro (12.9-inch) (2nd generation) ${WIFI_CELLULAR}`,
	"iPad7,3": `iPad Pro (10.5-inch) ${WIFI}`,
	"iPad7,4": `iPad Pro (10.5-inch) ${WIFI_CELLULAR}`,
	"iPad8,1": `iPad Pro (11-inch) (1st generation) ${WIFI}`,
	"iPad8,2": `iPad Pro (11-inch) (1st generation) ${WIFI}`,
	"iPad8,3": `iPad Pro (11-inch) (1st generation) ${WIFI_CELLULAR}`,
	"iPad8,4": `iPad Pro (11-inch) (1st generation) ${WIFI_CELLULAR}`,
	"iPad8,5": `iPad Pro (12.9-inch) (3rd generation) ${WIFI}`,
	"iPad8,6": `iPad Pro (12.9-inch) (3rd generation) ${WIFI}`,
	"iPad8,7": `iPad Pro (12.9-inch) (3rd generation) ${WIFI_CELLULAR}`,
	"iPad8,8": `iPad Pro (12.9-inch) (3rd generation) ${WIFI_CELLULAR}`,
	"iPad8,9": `iPad Pro (11-inch) (2nd generation) ${WIFI}`,
	"iPad8,10": `iPad Pro (11-inch) (2nd generation) ${WIFI_CELLULAR}`,
	"iPad8,11": `iPad Pro (12.9-inch) (4th generation) ${WIFI}`,
	"iPad8,12": `iPad Pro (12.9-inch) (4th generation) ${WIFI_CELLULAR}`,
	"iPad13,4": `iPad Pro (11-inch) (3rd generation) ${WIFI}`,
	"iPad13,5": `iPad Pro (11-inch) (3rd generation) ${WIFI_CELLULAR}`,
	"iPad13,6": `iPad Pro (11-inch) (3rd generation) ${WIFI_CELLULAR}`,
	"iPad13,7": `iPad Pro (11-inch) (3rd generation) ${WIFI_CELLULAR}`,
	"iPad13,8": `iPad Pro (12.9-inch) (5th generation) ${WIFI}`,
	"iPad13,9": `iPad Pro (12.9-inch) (5th generation) ${WIFI_CELLULAR}`,
	"iPad13,10": `iPad Pro (12.9-inch) (5th generation) ${WIFI_CELLULAR}`,
	"iPad13,11": `iPad Pro (12.9-inch) (5th generation) ${WIFI_CELLULAR}`,
	"iPad14,3": `iPad Pro 11-inch (M2) ${WIFI}`,
	"iPad14,4": `iPad Pro 11-inch (M2) ${WIFI_CELLULAR}`,
	"iPad14,5": `iPad Pro 12.9-inch (M2) ${WIFI}`,
	"iPad14,6": `iPad Pro 12.9-inch (M2) ${WIFI_CELLULAR}`,
	"iPad16,3": `iPad Pro 11-inch (M4) ${WIFI}`,
	"iPad16,4": `iPad Pro 11-inch (M4) ${WIFI_CELLULAR}`,
	"iPad16,5": `iPad Pro 13-inch (M4) ${WIFI}`,
	"iPad16,6": `iPad Pro 13-inch (M4) ${WIFI_CELLULAR}`,
	"iPad17,1": `iPad Pro 11-inch (M5) ${WIFI}`,
	"iPad17,2": `iPad Pro 11-inch (M5) ${WIFI_CELLULAR}`,
	"iPad17,3": `iPad Pro 13-inch (M5) ${WIFI}`,
	"iPad17,4": `iPad Pro 13-inch (M5) ${WIFI_CELLULAR}`,
};

export const getAppleDeviceName = (identifier) => {
	if (!identifier) {
		return null;
	}
	return APPLE_DEVICE_MODELS[identifier] ?? identifier;
};
